import apiClient from "./axios"; // Import the Axios instance

const loanApi = {
  // Fetch all loans
  getAll() {
    return apiClient.get("api/loans");
  },

  // Fetch a single loan by ID
  getById(id) {
    return apiClient.get(`api/loans/${id}`);
  },

    // ✅ Fetch a loan for VIEW MODE (rich payload)
  getViewById(id) {
    return apiClient.get(`api/loans/${id}/view`);
  },

  // Create a new loan
  create(data) {
    return apiClient.post("api/loans", data);
  },

    // Create a new loan
  calculate(data) {
    return apiClient.post("api/loans/calculate-repayment-schedule", data);
  },


  // Update an existing loan
  update(id, data) {
    return apiClient.put(`api/loans/${id}`, data);
  },

  // Update loan approval status
  updateApprovalStatus(id, data) {
    return apiClient.put(`api/loans/update-loan-approval-status/${id}`, data);
  },

  // Delete a loan by ID
  delete(id) {
    return apiClient.delete(`api/loans/${id}`);
  },

  // Fetch loans pending approval by a specific user
  getPendingApprovalByApprover() {
    return apiClient.get("api/loans/pending-approval");
  },

  // Fetch fully approved loans
  getApproved() {
    return apiClient.get("api/loans/approved");
  },

  // ✅ CORRECT: Disburse a loan with accountId as query param
  disburseLoan(id, accountId) {
    return apiClient.post(`api/loans/disburse/${id}`, null, {
      params: { disburserId: parseInt(accountId) }
    });
  },

  // Search/filter loans
  createBatchLoans(data) {
    return apiClient.post("api/loans/create-batch-loans", data);
  }

};

export default loanApi;
